module.exports = "/_next/static/images/7d710c7fddfcdf07cbcd10ce87392ebf-join-us-md-3x.png.webp";